import { CALENDAR_VIEW, SLICE_NAME } from "constants/common";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateQuery } from "../managerMeetingSlice";

export const TYPE_FETCH_MEETING = {
    ALL: 'all',
    HISTORY: 'history'
}

export const TYPE_MEETING = {
    MY_CALENDAR: 'MY_CALENDAR',
    INVITED: 'INVITED',
    // OTHER: 'OTHER'
}

export const GROUP_FUNCTION = {
    LICENSE: "LICENSE",
    ROLE: "ROLE"
}

export const LABEL_GROUP_FUNCTION = {
    LICENSE: "LICENSE",
    ROLE: "ROLE"
}

export const LABEL_TYPE_MEETING = {
    MY_CALENDAR: 'mnMeeting.myCalendar',
    INVITED: 'mnMeeting.invitedCalendar',
    OTHER: 'mnMeeting.otherCalender',
    IN_COMMING: 'mnMeeting.incoming',
    IN_PROGRESS: 'mnMeeting.inprogressing',
    ENDED: 'mnMeeting.ended',
    CANCEL: 'mnMeeting.canceled',
    OUT_OF_DATE: 'mnMeeting.outOfDate'
}

export const STATUS_MEETING = {
    IN_COMMING: 'IN_COMMING',
    IN_PROGRESS: 'IN_PROGRESS',
    ENDED: 'ENDED',
    CANCEL: 'CANCEL',
    OUT_OF_DATE: 'OUT_OF_DATE'
}

export const TYPE_TIME_CALENDAR = {
    DAY: 'DAY',
    WEEK: 'WEEK'
}

export const ACTION_CHANGE_TIME_CALENDAR = {
    NEXT: 'NEXT',
    CURRENT: 'CURRENT',
    PREV: 'PREV'
}

/**
 * Trả về loại cuộc họp theo format của api
 * Cuộc họp của tôi: 0
 * Cuộc họp được mời: 1
 * Cả 2: ''
 * @param {*} typeMeeting 
 * @returns 
 */
function typeMeetingQuery(typeMeeting = []) {
    if (!typeMeeting) return ''
    try {


        let typeMeetingCustom = '';
        if(typeMeeting?.length === 3){
            typeMeetingCustom = '0,1,2'
        }
        if(typeMeeting?.includes(TYPE_MEETING.INVITED) && typeMeeting?.length === 1){
            typeMeetingCustom = '1'
        }
        if(typeMeeting?.includes(TYPE_MEETING.MY_CALENDAR) && typeMeeting?.length === 1){
            typeMeetingCustom = '0'
        }
        if(typeMeeting?.includes(TYPE_MEETING.OTHER) && typeMeeting?.length === 1){
            typeMeetingCustom = '2'
        }
        if(typeMeeting?.includes(TYPE_MEETING.MY_CALENDAR) && typeMeeting?.includes(TYPE_MEETING.OTHER) && typeMeeting?.length === 2 ){
            typeMeetingCustom = '0,2'
        }
        if(typeMeeting?.includes(TYPE_MEETING.INVITED) && typeMeeting?.includes(TYPE_MEETING.OTHER) && typeMeeting?.length === 2){
            typeMeetingCustom = '1,2'
        }


        return typeMeetingCustom;

        // if (typeMeeting.includes(TYPE_MEETING.MY_CALENDAR) && typeMeeting.includes(TYPE_MEETING.INVITED) && typeMeeting?.length === 2) return ''
        // else if (typeMeeting.includes(TYPE_MEETING.MY_CALENDAR)) return '0'
        // else if (typeMeeting.includes(TYPE_MEETING.INVITED)) return '1'
        // else return ''
    } catch (err) {
        console.log("typeMeetingQuery", err);
    }
}

const useManagerMeeting = () => {
    // const [ statusMeeting, setStatusMeeting] = useState(Object.values(STATUS_MEETING))
    const [ statusMeeting, setStatusMeeting] = useState([])
    const { query } = useSelector(state => state[SLICE_NAME.MANAGER_MEETING])
    // const [ statusMeeting, setStatusMeeting] = useState(Object.values(STATUS_MEETING))
    const [typeMeeting, setTypeMeeting] = useState(() => {
        if(query?.typeMeeting === ""){
            return([TYPE_MEETING.MY_CALENDAR, TYPE_MEETING.INVITED])
        } else if(query?.typeMeeting === "0"){
            return([TYPE_MEETING.MY_CALENDAR])
        } else {
            return([TYPE_MEETING.INVITED])
        }
    })
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(updateQuery({ ...query, typeMeeting: typeMeetingQuery(typeMeeting) }))
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [typeMeeting,dispatch])

    /**
     * Xử lý loại cuộc họp [Của tôi | Được mời]
     * @param {*} type 
     * @param {*} checked 
     */
    const handleUpdateTypeMeeting = (type, checked) => {
        if (checked) {
            setTypeMeeting((prev) => [...prev, type])
        } else {
            setTypeMeeting((prev) => {
                if (prev.length === 1) {
                    if (type === TYPE_MEETING.MY_CALENDAR) return [TYPE_MEETING.INVITED]
                    return [TYPE_MEETING.MY_CALENDAR]
                } else return prev.filter(t => t !== type)
            })
        }
    }

    /**
     * Xử lý loại cuộc họp 
     * @param {*} type 
     * @param {*} checked 
     */
    const handleUpdateStatusMeeting = (type, checked) => {
        if (checked) {
            setStatusMeeting((prev) => [...prev, type])
            dispatch(updateQuery({...query, statusDisplay: [...statusMeeting, type]}))
        } else {
            setStatusMeeting((prev) => {
                const _prev = prev.filter(t => t !== type)
                if(_prev.length > 0) return _prev
                return []
            })
            const statusMeetingFinal = statusMeeting?.filter(item => item !== type)
            dispatch(updateQuery({...query, statusDisplay: statusMeetingFinal}))
        }
    }

    const handleChangeTimeInCalendar = (type, action, start, end) => {
        switch (type) {
            case CALENDAR_VIEW.TIME_GRID_DAY:
                dispatch(updateQuery({ ...query, start, end, page: 1 }))
                break;
            case CALENDAR_VIEW.TIME_GRID_WEEK:
                dispatch(updateQuery({ ...query, start, end, page: 1 }))
                break
            default:
                dispatch(updateQuery({ ...query, start, end, page: 1 }))
                break;
        }
    }

    const getStartTime = (type, value) => {
        if(type === CALENDAR_VIEW.TIME_GRID_DAY) return dayjs(value).startOf('day').unix()*1000
        return dayjs(value).day(1).startOf('day').unix()*1000
    }

    const getEndTime = (type, value) => {
        if(type === CALENDAR_VIEW.TIME_GRID_DAY) return dayjs(value).endOf('day').unix()*1000
        return dayjs(value).day(7).endOf('day').unix()*1000
    }

    return {
        typeMeeting,
        setTypeMeeting,
        statusMeeting,
        setStatusMeeting,
        handleUpdateTypeMeeting,
        handleUpdateStatusMeeting,
        handleChangeTimeInCalendar,
        getStartTime,
        getEndTime
    }
}

export default useManagerMeeting